import React from "react";
import LinesEllipsis from "react-lines-ellipsis";

export default function CursorTableItem({ text, onClick, hideHand }) {
  return (
    <div
      style={{
        fontSize: 17,
        height: 40,
        justifyContent: "center",
        display: "flex",
        flexDirection: "column",
        cursor: hideHand ? "default" : "pointer",
      }}
      onClick={onClick}
    >
      <strong style={{ fontWeight: "600",color:'#000' }}>
        {
          <LinesEllipsis
            text={text}
            maxLine="3"
            ellipsis="..."
            trimRight
            basedOn="letters"
          />
        }
      </strong>
    </div>
  );
}
